export default "__VITE_PUBLIC_ASSET__c651dc75__"